module.exports = __webpack_public_path__ + "fonts/Axiforma-ExtraBold.2aa236f.ttf";